<template>
  <transition name="loading-fade">
    <div
      v-if="active"
      class="loading-overlay"
      :class="{ 'loading-overlay--fixed': fixed }"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div class="loading-overlay__panel">
        <span class="loading-overlay__spinner" aria-hidden="true"></span>
        <span v-if="label" class="loading-overlay__label">{{ label }}</span>
        <span v-else class="loading-overlay__sr-only">Loading</span>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'LoadingOverlay',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.loading-overlay {
  position: absolute;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(248, 250, 252, 0.72);
  backdrop-filter: blur(2px);
}

.loading-overlay--fixed {
  position: fixed;
}

.loading-overlay__panel {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  min-width: 52px;
  min-height: 52px;
  padding: 10px;
}

.loading-overlay__spinner {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(22, 60, 82, 0.16);
  border-top-color: #163c52;
  border-radius: 50%;
  animation: loading-overlay-spin 0.75s linear infinite;
}

.loading-overlay__label {
  color: #163c52;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
}

.loading-overlay__sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.loading-fade-enter-active,
.loading-fade-leave-active {
  transition: opacity 0.16s ease;
}

.loading-fade-enter-from,
.loading-fade-leave-to {
  opacity: 0;
}

@keyframes loading-overlay-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
